/** Annotation geometry in the displayed x coordinate system. */
export type AnnotationItem = {
  id: string;
  status: 'before' | 'after' | 'at_start' | 'at_end' | 'within';
  xValue: number;
};

/** Stable source; only markers and chart draw hooks subscribe to hover. */
export type AnnotationHoverSource = {
  get: () => string | null;
  subscribe: (onChange: () => void) => () => void;
};

export type AnnotationQueryBounds = {
  xAxisMin?: number | null;
  xAxisMax?: number | null;
};

export const EMPTY_ANNOTATIONS: AnnotationItem[] = [];
export const EMPTY_ANNOTATION_HOVER: AnnotationHoverSource = {
  get: () => null,
  subscribe: () => () => {},
};
